module.exports = __webpack_public_path__ + "static/media/address.e3d5e880.svg";